/* eslint class-methods-use-this: "off", max-len: "off", no-console: "off" */

import React, { Component } from 'react';
import LanguageMenu from './LanguageMenu';
import PronounceMenu from './PronounceMenu';
import MobileChapters from './MobileChapters';
import TTSInput from './TTSInput';
import Controls from './Controls';
import NotSupported from './NotSupported';
import Notifications from './Notifications';
import LocationBar from './LocationBar';
import Translation from './Translation';

import supports from '../modules/supports';
import { Speak, getVoices, onvoiceschanged } from '../modules/audio';
import recognize from '../modules/speechrecognition';
import recorderPlayer from '../modules/recorderplayer';

const lamejs = require('lamejs');

import { saveAs } from 'file-saver';

import './Pronounce.css';
import {
  fetchExercises,
  launchExercise,
  clearExercise,
  launchText,
  selectText,
  clearText,
  updateSource,
  updateTranslation,
  nextSentence,
  prevSentence,
  spliceSentence,
  setUtteranceLength,
  setRecording,
  addResults,
  addHistory,
} from '../actions/actions';

class Pronounce extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceConfig: {
        supportsRecording: supports.recording(),
        allowsRecording: false,
        supportsTTS: supports.tts(),
        supportsSpeechRecognition: supports.speechRecognition(),
      },
      player: {
        isPlayingExample: false,
        isRecording: false,
        isPlayingRecording: false,
        startedRecording: null,
        activeRecordingID: null,
        errorMessage: '',
      },
      language: 'en-GB',
      mode: 'normal',
      ttsLanguage: 'en-GB',
      ttsRate: 1.0,
      activeVoice: 1,
      voices: [],
      initialLanguageLoaded: false,
      introExerciseOpened: false,
    };
  }

  componentWillMount() {
    this.updateVoices();

    if (
      this.state.deviceConfig.supportsRecording &&
      this.props.config.environment !== 'android'
    ) {
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      recorderPlayer.init(this.audioContext, this.updateMicrophonePermission);
    }
  }

  componentDidMount() {
    if (this.props.standAlone === false) {
      this.props.dispatch(fetchExercises());
    }
    // getVoices on speechSynthesis will return an empty array if called too early.
    // This hooks into SpeechSynthesis' onchange event for voices.
    onvoiceschanged(this.updateVoices);
  }

  componentWillReceiveProps(nextProps) {}

  componentDidUpdate(prevProps, prevState) {
    if (this.state.voices.length > 0 && !this.state.initialLanguageLoaded) {
      this.selectVoiceByLanguage('en-GB');
      this.setState({ initialLanguageLoaded: true });
    }

    if (
      prevProps.exercises.isFetching === true &&
      this.props.exercises.isFetching === false &&
      !this.state.introExerciseOpened &&
      this.props.openIntro &&
      this.props.exercises.exercises.length > 0
    ) {
      this.openIntroductoryExercise();
      this.setState({
        introExerciseOpened: true,
      });
    }

    // If the exercise was updated, relaunch it. It won't be updated automatically,
    // since we're actually dealing with a local and modified copy of the exercise.
    if (
      prevProps.exercises.isFetching === true &&
      prevProps.exercises.hasUpdated === false &&
      this.props.exercises.hasUpdated === true
    ) {
      if (prevProps.exercises.activeExercise !== null) {
        this.launchExercise(this.props.exercises.activeExercise);
      }
    }

    // If there's a new exercise, we want to open it automatically. We can compare
    // the exercise arrays in current and previous props, and deduce the new exercise from that.
    // This works for any order the API will return the exercises.
    if (
      prevProps.exercises.hasSaved === false &&
      this.props.exercises.hasSaved === true &&
      prevProps.exercises.exercises.length + 1 ===
        this.props.exercises.exercises.length
    ) {
      const oldExercises = [...prevProps.exercises.exercises];
      const newExercises = [...this.props.exercises.exercises];

      const difference = newExercises.filter((x) => {
        const filtered = oldExercises.filter(y => y.id === x.id);
        return filtered.length === 0;
      });

      if (difference.length === 1) {
        this.launchExercise(difference[0].originalIndex);
      }
    }
  }

  componentWillUnmount() {
    // The AudioContext needs to be closed on unmount. Otherwise re-rendering
    // this element will create a new AudioContext everytime, and there's a
    // maximum for how many there can be.
    this.audioContext.close();
  }

  openIntroductoryExercise = () => {
    console.log('open intro');
    const introExercise = this.findExerciseByName('Introductory Exercise');

    if (introExercise) {
      this.launchExercise(introExercise.originalIndex);
    }
  };

  findExerciseByName = (name) => {
    console.log('find byname');
    let exerciseByName = null;

    for (const exercise of this.props.exercises.exercises) {
      if (exercise.name.toLowerCase() === name.toLowerCase()) {
        exerciseByName = exercise;
        break;
      }
    }

    return exerciseByName;
  };

  logPlayExample = () => {
    this.setState({
      player: { ...this.state.player, startedRecording: performance.now() },
    });
  };

  logPlayExampleStop = () => {
    const utteranceLength =
      performance.now() - this.state.player.startedRecording;

    this.props.dispatch(setUtteranceLength(utteranceLength));
    this.setState({
      player: {
        ...this.state.player,
        isPlayingExample: false,
        startedRecording: null,
      },
    });
  };

  logPlayExampleError = (error) => {
    console.error(error);
    this.setState({
      player: {
        ...this.state.player,
        isPlayingExample: false,
        startedRecording: null,
      },
    });
  };

  togglePlayExample = () => {
    this.resetErrors();
    if (this.isStopped()) {
      this.setState({
        player: { ...this.state.player, isPlayingExample: true },
      });

      const isAndroid = this.props.config.environment === 'android';

      Speak.speak(
        this.props.text.texts[this.props.text.activeText].source,
        this.state.ttsLanguage,
        this.state.voices[this.state.activeVoice],
        isAndroid,
        this.logPlayExample,
        this.logPlayExampleStop,
        this.logPlayExampleError,
        this.state.ttsRate,
      );
    } else if (this.state.player.isPlayingExample) {
      // If the user stops the example (instead of letting it play in whole),
      // reset startedRecording. Otherwise a misleading length is used to decide
      // when to pause recording automatically.
      this.setState({
        player: {
          ...this.state.player,
          isPlayingExample: false,
          startedRecording: null,
        },
      });
      Speak.cancel();
    }
  };

  record = () => {
    this.resetErrors();
    if (this.isStopped()) {
      let recID = null;
      const length =
        this.props.text.texts[this.props.text.activeText].utteranceLength ||
        20000;

      const recLength = length * 2;
      const stopAt = performance.now() + recLength;

      // We're using requestAnimationFrame to test whether the recording should be stopped or not.
      // Note that if the tab is inactive, different browsers behave differently. Chrome
      // only calls requestAnimationFrame the next time the tab is active,
      // which could lead into funny situations.
      const step = (timestamp) => {
        if (this.state.player.activeRecordingID === null) {
          return;
        }
        if (timestamp < stopAt) {
          window.requestAnimationFrame(step);
        } else {
          this.stop();
        }
      };

      recID = window.requestAnimationFrame(step);
      const newState = { ...this.state };
      newState.player.isRecording = true;
      newState.player.activeRecordingID = recID;
      this.setState({ ...newState });

      if (this.props.config.environment !== 'android') { recorderPlayer.startRecording(this.setRecording); }
      if (this.state.deviceConfig.supportsSpeechRecognition) { this.startRecognizing(); }
    } else {
      this.stop();
    }
  };

  stop = () => {
    if (this.isStopped()) {
      return;
    }

    if (this.state.player.activeRecordingID !== null) {
      window.cancelAnimationFrame(this.state.player.activeRecordingID);
    }
    const newState = { ...this.state };
    newState.player.isRecording = false;
    newState.player.activeRecordingID = null;
    this.setState({ ...newState });

    if (this.props.config.environment !== 'android') { recorderPlayer.stopRecording(); }
    if (this.state.deviceConfig.supportsSpeechRecognition) { this.stopRecognizing(); }
  };

  toggleRecordPlayback = () => {
    if (this.state.player.isPlayingRecording === true) {
      this.stopPlayingRecording();
    } else {
      this.playRecording();
    }
  };

  playRecording = () => {
    if (this.isStopped()) {
      const audioBuffer = this.props.text.texts[this.props.text.activeText]
        .audioBuffer;
      if (this.props.config.environment !== 'android') { recorderPlayer.play(audioBuffer, this.stopPlayingRecording); }

      const newState = { ...this.state };
      newState.player.isPlayingRecording = true;
      this.setState({ ...newState });
    }
  };

  stopPlayingRecording = () => {
    if (this.state.player.isPlayingRecording === true) {
      if (this.props.config.environment !== 'android') recorderPlayer.stop();
      const newState = { ...this.state };
      newState.player.isPlayingRecording = false;
      this.setState({ ...newState });
    }
  };

  resetErrors = () => {
    this.setState({ player: { ...this.state.player, errorMessage: '' } });
  };

  startRecognizing = () => {
    this.resetErrors();
    recognize.setOnEndCallback(this.handleSpeechRecEnd);
    recognize.setOnErrorCallback(this.handleSpeechRecError);
    recognize.start(this.state.language);
  };

  stopRecognizing = () => {
    recognize.stop();
  };

  handleSpeechRecError = (error) => {
    let message;

    if (error === 'network') {
      message = 'Network is down - please check your connection';
    } else if (error === 'audio-capture') {
      message =
        'Something is wrong with the audio capture - please check your microphone';
    }
    this.setState({ player: { ...this.state.player, errorMessage: message } });
    this.stop();
  };

  setRecording = (buffer, originalFloat32ArrayBuffers) => {
    this.props.dispatch(setRecording(buffer, originalFloat32ArrayBuffers));
  };

  isStopped = () =>
    !this.state.player.isPlayingExample &&
    !this.state.player.isRecording &&
    !this.state.player.isPlayingRecording;

  selectVoice = (index) => {
    const lang = this.state.voices[index].lang;
    const ttsLang = this.state.voices[index].ttsLang || lang;
    this.setState({ language: lang, ttsLanguage: ttsLang, activeVoice: index });

    window.pronounceConfig.lang = lang;
  };

  setRate = (rate) => {
    this.setState({ ttsRate: rate });
  };

  selectVoiceByLanguage = (lang) => {
    let index = 0;
    for (const voice of this.state.voices) {
      console.log(voice);
      if (voice.lang.toLowerCase() === lang.toLowerCase()) {
        console.log('FOUND VOICe');
        this.selectVoice(index);
        break;
      }
      index += 1;
    }
  };

  updateVoices = () => {
    const voices = getVoices();
    this.setState({ voices });
  };

  updateMicrophonePermission = (permission) => {
    const deviceConfig = { ...this.state.deviceConfig };
    deviceConfig.allowsRecording = permission;
    this.setState({ deviceConfig });
  };

  askMicrophonePermission = () => {
    recorderPlayer.setup(this.updateMicrophonePermission);
  };

  handleSpeechRecEnd = () => {
    const results = recognize.getResults();
    if (results.result !== null) {
      this.props.dispatch(addResults(results));
      this.props.dispatch(
        addHistory({
          text: this.props.text.texts[this.props.text.activeText].source,
          results,
          language: this.state.language,
        }),
      );
    }
    recognize.reset();
  };

  launchExercise = (index) => {
    if (this.props.exercises.exercises[index]) {
      this.selectVoiceByLanguage(
        this.props.exercises.exercises[index].language,
      );
      this.props.dispatch(launchExercise(index));
      this.props.dispatch(
        launchText(this.props.exercises.exercises[index].text),
      );
    }
  };

  saveExercise = () => {};

  clearExercise = () => {
    this.props.dispatch(clearExercise());
    this.props.dispatch(clearText());
  };

  floatTo16BitPCM = (input, output) => {
    for (let i = 0; i < input.length; i++) {
      const s = Math.max(-1, Math.min(1, input[i]));
      output[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
  };

  convertBuffer = (float32Array) => {
    const data = new Float32Array(float32Array);
    const out = new Int16Array(float32Array.length);
    this.floatTo16BitPCM(data, out);
    return out;
  };

  downloadAudio = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const audioBuffer = this.props.text.texts[this.props.text.activeText]
      .audioBuffer;
    const float32ArrayBuffers = this.props.text.texts[
      this.props.text.activeText
    ].float32ArrayBuffers;
    const mp3Data = [];

    const mp3encoder = new lamejs.Mp3Encoder(1, audioBuffer.sampleRate, 96); // mono 44.1khz encode to 128kbps
    const samples = this.convertBuffer(float32ArrayBuffers[0]);
    let mp3Tmp = mp3encoder.encodeBuffer(samples); // encode mp3

    // Push encode buffer to mp3Data variable
    mp3Data.push(mp3Tmp);

    // Get end part of mp3
    mp3Tmp = mp3encoder.flush();

    // Write last data to the output data, too
    // mp3Data contains now the complete mp3Data
    mp3Data.push(mp3Tmp);

    const blob = new Blob(mp3Data, { type: 'audio/mpeg' });

    const exercise = this.props.exercises.activeExercise !== null
      ? this.props.exercises.exercises[this.props.exercises.activeExercise]
      : null;

    let name = exercise ? exercise.name : 'no-exercise';

    name = name.replace(/[^a-z0-9]/gi, '_').toLowerCase();

    const filename = `pronounce-live-${name}-phrase-${
      this.props.text.activeText
    }.mp3`;

    saveAs(blob, filename);
  };

  render() {
    const config = this.state.deviceConfig;

    let mode = 'normal';
    let exercise = null;

    if (this.props.exercises.activeExercise) {
       exercise = this.props.exercises.exercises[this.props.exercises.activeExercise];

      if (exercise.mode) {
        mode = exercise.mode;
      }
    }

    if (!config.supportsTTS || !config.supportsSpeechRecognition) {
      return <NotSupported />;
    }

    return (
      <div className="pronounce-module">
        <div className="pronounce-toolbar">
          <LanguageMenu
            activeVoice={this.state.activeVoice}
            voices={this.state.voices}
            selectVoice={this.selectVoice}
            isStopped={this.isStopped}
          />
          <PronounceMenu
            auth={this.props.auth}
            language={this.state.language}
            text={this.props.text}
            isWaiting={this.props.isWaiting}
            standAlone={this.props.standAlone}
            dispatch={this.props.dispatch}
            config={this.state.deviceConfig}
            isStopped={this.isStopped}
            exercises={this.props.exercises}
            voices={this.state.voices}
            saveExercise={this.saveExercise}
            launchExercise={this.launchExercise}
            clearExercise={this.clearExercise}
            history={this.props.history}
          />
        </div>
        <LocationBar exercises={this.props.exercises} />
        <TTSInput
          auth={this.props.auth}
          language={this.state.language}
          mode={mode}
          clearExercise={this.clearExercise}
          text={this.props.text}
          isWaiting={this.props.isWaiting}
          dispatch={this.props.dispatch}
          isStopped={this.isStopped}
          isRecording={this.state.player.isRecording}
          exercises={this.props.exercises}
          texts={this.props.text.texts}
          updateSource={updateSource}
          launchText={launchText}
          spliceSentence={spliceSentence}
        />
        <MobileChapters
          dispatch={this.props.dispatch}
          isStopped={this.isStopped}
          activeText={this.props.text.activeText}
          texts={this.props.text.texts}
          selectText={selectText}
          prev={prevSentence}
          next={nextSentence}
        />
        <Notifications
          config={this.props.config}
          deviceConfig={this.state.deviceConfig}
          askMicrophonePermission={this.askMicrophonePermission}
          errorMessage={this.state.player.errorMessage}
        />
        <Controls
          config={this.props.config}
          deviceConfig={this.state.deviceConfig}
          isStopped={this.isStopped}
          voices={this.state.voices}
          text={this.props.text}
          mode={mode}
          togglePlayExample={this.togglePlayExample}
          isPlayingExample={this.isPlayingExample}
          record={this.record}
          isRecording={this.state.player.isRecording}
          isPlayingRecording={this.state.player.isPlayingRecording}
          toggleRecordPlayback={this.toggleRecordPlayback}
          rate={this.state.ttsRate}
          setRate={this.setRate}
          downloadAudio={this.downloadAudio}
        />
      {exercise && exercise.translations && <Translation dispatch={this.props.dispatch} updateTranslation={updateTranslation} source={this.state.language} text={this.props.text} />}
      </div>
    );
  }
}

export default Pronounce;



// WEBPACK FOOTER //
// ./src/components/Pronounce.js